"use strict";
/**
 * After fund release (escrow → actual wallet), move the net released amount from the escrow bank
 * mapping to the actual bank mapping in Xero/QBO.
 *
 * ## Treatment (Pheng / HAN-420 / Nucleus wallet mirror)
 * - Dr {@link AccountingAccountMappingSlot.HANDSHAKE_ACTUAL_BANK} (via bank transfer)
 * - Cr {@link AccountingAccountMappingSlot.HANDSHAKE_ESCROW_BANK}
 *
 * - **Handshake**: full milestone (platform fee already booked on actual at pay-in), minus any
 *   CaseTrust share already released on payment.
 * - **Nucleus**: milestone minus platform fee (fee SPEND already credited escrow).
 *
 * ## Trigger
 * Invoice escrow fully released (milestone approved / instant release), after payment allocation.
 * Handshake CaseTrust release on payment ({@link ACCOUNTING_ESCROW_TO_ACTUAL_CASE_PAY_IN_SUFFIX})
 * posts the released share at pay-in.
 *
 * ## Idempotency
 * `project_invoice_escrow_to_actual:{projectInvoiceId}:{suffix}`
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTING_ESCROW_TO_ACTUAL_SYNC_IDEMPOTENCY_PREFIX = exports.ACCOUNTING_SYNC_OPERATION_RECORD_ESCROW_TO_ACTUAL_RELEASE = exports.ACCOUNTING_ESCROW_TO_ACTUAL_CASE_PAY_IN_SUFFIX = void 0;
exports.parseAccountingEscrowToActualIdempotencyKey = parseAccountingEscrowToActualIdempotencyKey;
exports.buildAccountingEscrowToActualIdempotencyKey = buildAccountingEscrowToActualIdempotencyKey;
exports.isRecordEscrowToActualReleaseAccountingSyncOp = isRecordEscrowToActualReleaseAccountingSyncOp;
exports.ACCOUNTING_ESCROW_TO_ACTUAL_CASE_PAY_IN_SUFFIX = "case_pay_in";
exports.ACCOUNTING_SYNC_OPERATION_RECORD_ESCROW_TO_ACTUAL_RELEASE = "RECORD_ESCROW_TO_ACTUAL_RELEASE";
exports.ACCOUNTING_ESCROW_TO_ACTUAL_SYNC_IDEMPOTENCY_PREFIX = "project_invoice_escrow_to_actual:";
const PROJECT_INVOICE_ESCROW_TO_ACTUAL_KEY_UUID = /^project_invoice_escrow_to_actual:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}):(.+)$/i;
function parseAccountingEscrowToActualIdempotencyKey(idempotencyKey) {
    const match = idempotencyKey.match(PROJECT_INVOICE_ESCROW_TO_ACTUAL_KEY_UUID);
    if (!match) {
        return null;
    }
    return { projectInvoiceId: match[1], idempotencySuffix: match[2] };
}
function buildAccountingEscrowToActualIdempotencyKey(projectInvoiceId, idempotencySuffix) {
    return `${exports.ACCOUNTING_ESCROW_TO_ACTUAL_SYNC_IDEMPOTENCY_PREFIX}${projectInvoiceId}:${idempotencySuffix}`;
}
function isRecordEscrowToActualReleaseAccountingSyncOp(operation) {
    return operation === exports.ACCOUNTING_SYNC_OPERATION_RECORD_ESCROW_TO_ACTUAL_RELEASE;
}
